interface ChartTextExportPlaceholderProps {
  text: string;
}

export const ChartTextExportPlaceholder = ({
  text,
}: ChartTextExportPlaceholderProps) => (
  <div className="tcw-chart-card ecp__chart-empty">
    <p className="ecp__chart-empty-text">{text}</p>
  </div>
);
